export enum AsyncReportEnum {
   DailyLog = "DailyLog",
   DeferredRx = "FiledRx",
   RxByPharmacist = "RxByPharmacist",
   ControlRx = "ControlRx",
   RxByPrescriber = "RxByPrescriber",
   UnbilledRx = "UnbilledRx",
   RxNotPickedup = "NotPickUpRx",
   RxTransferredReport = "RxTransferredReport",
   SalesTaxSummary = "PharmCustomReports",
   PartialFill = "PartialFill",
   InventoryStatus = "Inventory",
   DrugDispensed = "DrugDispensed",
   DrugDispensedEquivalency = "DrugDispensedEquivalency",
   RefillExpiration = "RefillExpiration",
   RefillDue = "RefillDue",
   PatientMedicationAdherenceReport = "PatientMedicationAdherenceReport",
   priceReport = "Pricereport",
   AuditTrail = "AuditTrail",
   RxsByInsurance = "RxsByInsurance",
   SummaryReports = "SummaryReports",
   ProfitRevenueReports = "ProfitRevenueReports",
   TopPerformersReports = "TopPerformers",
   rxlistwithnoattdocs = "rxlistwithnoattdocs",
   rxlistwithattdocs = "rxlistwithattdocs",
   erx = "erx",
   RxFilledSummary = "RXFilledSummary",
   PatientHippaAckReport = "HipaaAck",
   RxPickupLog = "RxPickupLog",
   SignatureClaimsLog = "SignatureClaimsLog",
   pickUpDetails = "pickUpDetails",
   posCopayCollected = "posCopayCollected",
   InventoryReconciliation = "InventoryReconciliation",
   EDI835Remittance = "EDI835Remittance",
   IOUReport = "IOU",
   NotesReport = "Notes",
   ReturnToStock = "ReturnToStock",
   ViewInventory = "ViewInventory",
   ViewEDI835Data = "ViewEDI835Data",
   DrugLotExpirationReport = "DrugLotExpirationReport",
   CallLog = "CallLog",
   ProfitRevenueDataSet ="ProfitRevenueDataSet",

}
export enum AsyncReportNameEnum {
    DailyLog = "Daily Log",
    FiledRx = "Deferred Rx",
    RxByPharmacist = "Rx By Pharmacist",
    ControlRx = "Control Rx",
    RxByPrescriber = "Rx By Prescriber",
    UnbilledRx = "Unbilled Rx",
    NotPickUpRx = "Rxs Not Pickep Up",
    RxTransferredReport = "Transferred Rxs",
    PharmCustomReports = "Sales Tax Summary",
    PartialFill = "Partial Fill",
    InventoryStatus = "Inventory Status",
    DrugDispensed = "Drug Dispensed",
    DrugDispensedEquivalency = "Drug Dispensed By Equivalency",
    RefillExpiration = "Refill Expiration",
    RefillDue = "Refills Due",
    PatientMedicationAdherenceReport = "Patient Medication Adherence",
    Pricereport = "Price",
    AuditTrail = "Audit Trail",
    RxsByInsurance = "Rxs By Insurance",
    SummaryReports = "Business Summary",
    ProfitRevenueReports = "Profit Revenue",
    rxlistwithnoattdocs = "Print Rx List With No Attached Documents",
    rxlistwithattdocs = "Print Rx List With Attached Documents",
    erx = "eRx",
    RxFilledSummary = "Rx Filled Summary",
    HipaaAck = "Patient Hippa Acknowledgement",
    RxPickupLog = "Print Rx Pickup Log",
    SignatureClaimsLog = "Signature Claims Log",
    pickUpDetails = "Include Rx PickUp Details",
    posCopayCollected = "POS - Copay Collected",
    InventoryReconciliation = "Perpetual Inventory",
    EDI835Remittance = "EDI 835 Remittance",
    IOUReport = "IOU",
    NotesReport = "Notes",
    ReturnToStock = "Return to Stock",
    ViewInventory = "View Inventory",
    ViewEDI835Data = "View EDI835 Data",
    AnalyseAudit = "Analyse Audit",
    DataSet ="Data Set",
    TopPerfomers = "Top Perfomers",
    PriceChange = "Price Change",
    DrugLotExpirationReport = "Drug Lot Expiration Report",
    CallLog = "Call Log",
    ProfitRevenueDataSet = "Profit Revenue Dataset",
 }
export enum reportsEnum {
    Reports = 1,
    DMS = 2,
    eRx = 3,
    electronicSignature = 4,
    Rx = 5,
    Inventory = 6,
    EDIReports = 7,
    Communication = 8
}
